




























import { Component, Vue, Prop } from 'nuxt-property-decorator';

import { IconArrowRight } from '@/icons';

export interface AccordionSection {
  title: string;
  content: string;
  subtitle?: string;
  description?: string;
  image?: string;
}

@Component({
  components: {
    IconArrowRight,
  },
})
export default class BlockAccordion extends Vue {
  // TODO: add bg type
  @Prop(String)
  backgroundColor!: string

  @Prop(String)
  title!: string

  @Prop({ type: Array, required: true })
  content!: AccordionSection[];

  getId (index: any) {
    const uid = this._uid;
    return `accordion-${uid}-${index}`;
  }
}
